import { isAxiosError } from "axios";

type ApiErrorPayload = {
  code: string;
  message?: string;
}[];

// Code enum to message string mapping for easier usage in components
type ApiErrorMap = {
  [code: string]: string;
};

/**
 * Extract errors from API error response.
 * The errors are returned as an object like so:
 *
 * ```js
 * {
 *   PASSWORD_LENGTH_ERROR: "Password must be at least 8 characters long",
 *   PASSWORD_COMPLEXITY_ERROR: "Password must contain at least one number",
 *   LEVEL_BUILDING_CONSTRAINT_ERROR: "Level cannot be turned into a building"
 * }
 * ```
 *
 * NOTE: Do not use the error message directly in the UI, but instead use
 * the error code to display a custom translated message.
 */
export function getApiErrors(error: unknown): ApiErrorMap {
  const errors: ApiErrorMap = {};

  if (isAxiosError(error)) {
    const { response } = error;

    if (response?.data?.errors && Array.isArray(response.data.errors)) {
      const apiErrors = response.data.errors as ApiErrorPayload;

      apiErrors.forEach((apiError) => {
        if (apiError.code) {
          errors[apiError.code] = apiError.message || apiError.code;
        }
      });
    }
  }

  return errors;
}
